/**
 * @generated SignedSource<<8b6a74957a2378a2bb6d63cefb704fee>>
 * @relayHash 45a4a6553eea3d28c4b21f7d5422a13f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 03170320137388b58c5cf52c75a231a74439ce2b30fd9a6321346f09e4fca5d0

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssetsVerticalPermissionCheckInput = {
  dontRequirePrincipalInSite?: boolean | null;
  permissionId: string;
  resourceId: string;
};
export type GSNQueryPreloaderQuery$variables = {
  cloudId: string;
  currentURL?: AGG$URL | null;
  entityAriApps?: string | null;
  entityAriFilters?: string | null;
  entityAriPlans: string;
  entityAriRoadmaps?: string | null;
  entityAriUserSideNavSettings: string;
  fetchGlobalShortcutsAvailableProducts: boolean;
  invitedAppShortcutsProduct: string;
  isAppsExpanded?: boolean | null;
  isFiltersExpanded?: boolean | null;
  isItamEnabled: boolean;
  isOperationsExpanded?: boolean | null;
  isPlansExpanded?: boolean | null;
  isProjectsExpanded?: boolean | null;
  itamStaticChecks: ReadonlyArray<AssetsVerticalPermissionCheckInput>;
  navPlatMenuDataEntityAri: string;
  navPlatSidebarDataEntityAri: string;
  ownerAri?: string | null;
  shouldFetchInvitedAppShortcuts: boolean;
};
export type GSNQueryPreloaderQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GSNForContentSidebarEntryPoint" | "GSNForOtherSidebars">;
};
export type GSNQueryPreloaderQuery = {
  response: GSNQueryPreloaderQuery$data;
  variables: GSNQueryPreloaderQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNav4SidebarEmptyOnDbErrorRelayProvidertsx": isNav4SidebarEmptyOnDbErrorEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": isActionMenuWithAddPeopleSpotlightIdEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx": isJpdRoadmapsRecentsEnabled_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNav4SidebarEmptyOnDbErrorRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx: {
    readonly get: () => boolean;
  };
});

import isActionMenuWithAddPeopleSpotlightIdEnabled_provider from '@jira/platform__graphql-relay-provider/src/JsmEnableActionMenuAddPeopleSpotlightIdRelayProvider';
import isNav4SidebarEmptyOnDbErrorEnabled_provider from '@jira/platform__graphql-relay-provider/src/Nav4SidebarEmptyOnDbErrorRelayProvider';
import isSubspaceEnabled_provider from '@jira/platform__graphql-relay-provider/src/atlas-project-native-integration-m2.relayprovider';
import isJpdRoadmapsRecentsEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJpdRoadmapsRecentsEnabled';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentURL"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriApps"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriFilters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriPlans"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriRoadmaps"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriUserSideNavSettings"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchGlobalShortcutsAvailableProducts"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "invitedAppShortcutsProduct"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isAppsExpanded"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isFiltersExpanded"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isItamEnabled"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isOperationsExpanded"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPlansExpanded"
},
v14 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isProjectsExpanded"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itamStaticChecks"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "navPlatMenuDataEntityAri"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "navPlatSidebarDataEntityAri"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchInvitedAppShortcuts"
},
v20 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v21 = [
  {
    "concreteType": "SettingsMenuItem",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "menuId"
      },
      {
        "kind": "ScalarField",
        "name": "visible"
      }
    ]
  }
],
v22 = {
  "concreteType": "SettingsMenuItemConnection",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": (v21/*: any*/)
},
v23 = [
  {
    "concreteType": "SettingsDisplayProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
],
v24 = {
  "kind": "ScalarField",
  "name": "id"
},
v25 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v26 = [
  (v25/*: any*/)
],
v27 = [
  {
    "args": (v26/*: any*/),
    "concreteType": "SettingsMenuItemConnection",
    "kind": "LinkedField",
    "name": "sidebar",
    "plural": false,
    "selections": (v21/*: any*/),
    "storageKey": "sidebar(first:100)"
  },
  {
    "args": (v26/*: any*/),
    "concreteType": "SettingsDisplayPropertyConnection",
    "kind": "LinkedField",
    "name": "properties",
    "plural": false,
    "selections": (v23/*: any*/),
    "storageKey": "properties(first:100)"
  },
  (v24/*: any*/)
],
v28 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v29 = [
  (v28/*: any*/)
],
v30 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v32 = {
  "kind": "ScalarField",
  "name": "label"
},
v33 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v34 = {
  "kind": "ScalarField",
  "name": "url"
},
v35 = {
  "order": "DESC"
},
v36 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v37 = {
  "kind": "ScalarField",
  "name": "title"
},
v38 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v39 = {
  "concreteType": "JiraFavouriteValue",
  "kind": "LinkedField",
  "name": "favouriteValue",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v24/*: any*/)
  ]
},
v40 = {
  "kind": "InlineFragment",
  "selections": [
    (v24/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v41 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v31/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v24/*: any*/),
          {
            "kind": "ScalarField",
            "name": "collectionId"
          },
          (v37/*: any*/),
          {
            "kind": "ScalarField",
            "name": "emoji"
          },
          (v39/*: any*/)
        ],
        "type": "JiraProductDiscoveryCollection"
      },
      (v40/*: any*/)
    ]
  }
],
v42 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v43 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v44 = {
  "kind": "ScalarField",
  "name": "productType"
},
v45 = {
  "kind": "ScalarField",
  "name": "message"
},
v46 = [
  (v22/*: any*/),
  (v24/*: any*/)
],
v47 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v48 = {
  "kind": "ScalarField",
  "name": "name"
},
v49 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v31/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v24/*: any*/)
      ]
    }
  ],
  "type": "JiraCustomFilter"
},
v50 = [
  (v24/*: any*/),
  (v48/*: any*/),
  {
    "kind": "ScalarField",
    "name": "alertSearchQuery"
  }
],
v51 = [
  (v34/*: any*/)
],
v52 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v31/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v24/*: any*/),
          {
            "kind": "ScalarField",
            "name": "planId"
          },
          (v37/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isReadOnly"
          },
          {
            "kind": "ScalarField",
            "name": "planStatus"
          },
          (v39/*: any*/),
          {
            "concreteType": "JiraScenario",
            "kind": "LinkedField",
            "name": "scenario",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "scenarioId"
              },
              (v24/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v51/*: any*/),
                "type": "JiraSoftwareBuiltInNavigationItem"
              },
              (v40/*: any*/)
            ]
          }
        ],
        "type": "JiraPlan"
      },
      (v40/*: any*/)
    ]
  }
],
v53 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v54 = {
  "kind": "ScalarField",
  "name": "status"
},
v55 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v56 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "large"
    }
  ]
},
v57 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v58 = {
  "kind": "LinkedField",
  "name": "defaultNavigationItem",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v51/*: any*/),
      "type": "JiraNavigationItem",
      "abstractKey": "__isJiraNavigationItem"
    },
    (v40/*: any*/)
  ]
},
v59 = {
  "args": [
    {
      "kind": "Literal",
      "name": "type",
      "value": "EDIT_PROJECT_CONFIG"
    }
  ],
  "concreteType": "JiraProjectAction",
  "kind": "LinkedField",
  "name": "action",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canPerform"
    }
  ],
  "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
},
v60 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v61 = {
  "kind": "ScalarField",
  "name": "softwareBoardCount"
},
v62 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v63 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": "subspaceCount",
          "kind": "ScalarField",
          "name": "subspaceCount_cse"
        }
      ]
    }
  ]
},
v64 = [
  (v24/*: any*/),
  (v53/*: any*/),
  (v54/*: any*/),
  (v55/*: any*/),
  (v56/*: any*/),
  (v48/*: any*/),
  (v57/*: any*/),
  (v38/*: any*/),
  (v58/*: any*/),
  (v59/*: any*/),
  (v60/*: any*/),
  (v61/*: any*/),
  (v62/*: any*/),
  (v63/*: any*/)
],
v65 = {
  "concreteType": "JiraProjectEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v64/*: any*/)
    }
  ]
},
v66 = {
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v31/*: any*/),
    {
      "kind": "ScalarField",
      "name": "statusCode"
    },
    {
      "kind": "ScalarField",
      "name": "errorType"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GSNQueryPreloaderQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "GSNForContentSidebarEntryPoint"
      },
      {
        "kind": "FragmentSpread",
        "name": "GSNForOtherSidebars"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v12/*: any*/),
      (v17/*: any*/),
      (v16/*: any*/),
      (v18/*: any*/),
      (v7/*: any*/),
      (v11/*: any*/),
      (v15/*: any*/),
      (v19/*: any*/),
      (v8/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNav4SidebarEmptyOnDbErrorRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx"
      }
    ],
    "kind": "Operation",
    "name": "GSNQueryPreloaderQuery",
    "selections": [
      {
        "alias": "userSideNavSettings",
        "args": [
          {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "entityAriUserSideNavSettings"
          },
          (v20/*: any*/)
        ],
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": [
          (v22/*: any*/),
          {
            "concreteType": "SettingsDisplayPropertyConnection",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": (v23/*: any*/)
          },
          (v24/*: any*/)
        ]
      },
      {
        "alias": "navPlatL1MenuData",
        "args": [
          {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "navPlatMenuDataEntityAri"
          },
          (v20/*: any*/)
        ],
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v27/*: any*/)
      },
      {
        "alias": "navPlatSidebarData",
        "args": [
          {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "navPlatSidebarDataEntityAri"
          },
          (v20/*: any*/)
        ],
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": (v27/*: any*/)
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isAppsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v29/*: any*/),
                "concreteType": "JiraNavigationItemConnection",
                "kind": "LinkedField",
                "name": "globalAppNavigationItems",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  {
                    "concreteType": "JiraNavigationItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v24/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v32/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "appType"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "envLabel"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "iconUrl"
                              },
                              (v33/*: any*/),
                              {
                                "concreteType": "JiraAppSection",
                                "kind": "LinkedField",
                                "name": "sections",
                                "plural": true,
                                "selections": [
                                  (v32/*: any*/),
                                  {
                                    "concreteType": "JiraAppNavigationItemNestedLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v34/*: any*/),
                                      (v33/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "settingsUrl"
                              },
                              (v34/*: any*/)
                            ],
                            "type": "JiraAppNavigationItem"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isFiltersExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "hasIsFiltersExpanded",
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          },
          {
            "condition": "isProjectsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "hasIsProjectsExpanded",
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          },
          {
            "alias": "shouldDisplay",
            "args": [
              (v28/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "VIEW_PROJECT_CREATION_ENTRY"
              }
            ],
            "kind": "ScalarField",
            "name": "canPerform"
          },
          {
            "alias": "roadmapFavourites",
            "args": [
              (v28/*: any*/),
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "sort": (v35/*: any*/),
                  "type": "JPD_COLLECTION"
                }
              },
              (v36/*: any*/)
            ],
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              (v30/*: any*/),
              {
                "concreteType": "JiraFavouriteEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v41/*: any*/)
              },
              (v42/*: any*/)
            ]
          },
          {
            "alias": "roadmapRecents",
            "args": [
              (v28/*: any*/),
              (v43/*: any*/),
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "JPD_COLLECTION"
                ]
              }
            ],
            "concreteType": "JiraSearchableEntityConnection",
            "kind": "LinkedField",
            "name": "recentItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSearchableEntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v41/*: any*/)
              },
              (v42/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isPlansExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "hasIsPlansExpanded",
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          },
          {
            "args": (v29/*: any*/),
            "concreteType": "JiraAdvancedRoadmapsNavigation",
            "kind": "LinkedField",
            "name": "advancedRoadmapsNavigation",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasEditPermissions"
              },
              {
                "kind": "ScalarField",
                "name": "hasCreateSamplePlanPermissions"
              },
              {
                "kind": "ScalarField",
                "name": "hasGlobalPlansAdminPermissions"
              }
            ]
          }
        ]
      },
      {
        "condition": "fetchGlobalShortcutsAvailableProducts",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v29/*: any*/),
            "kind": "LinkedField",
            "name": "appSwitcher_availableProductsBySite",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": true,
                    "selections": [
                      (v31/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v44/*: any*/),
                          (v34/*: any*/)
                        ],
                        "type": "AppSwitcherSingleUrlProduct"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v44/*: any*/),
                          {
                            "concreteType": "AppSwitcherProductSite",
                            "kind": "LinkedField",
                            "name": "sites",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "siteId"
                              },
                              (v34/*: any*/)
                            ]
                          }
                        ],
                        "type": "AppSwitcherSiteScopedProduct"
                      }
                    ]
                  }
                ],
                "type": "AppSwitcherAvailableProductsBySite"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v45/*: any*/)
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      },
      {
        "condition": "isAppsExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "appsOrder",
            "args": [
              {
                "kind": "Variable",
                "name": "entityAri",
                "variableName": "entityAriApps"
              },
              (v20/*: any*/)
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": (v46/*: any*/)
          }
        ]
      },
      {
        "condition": "isFiltersExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "favouriteFilters",
                "args": [
                  (v28/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": (v35/*: any*/),
                      "type": "FILTER"
                    }
                  },
                  (v36/*: any*/)
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v24/*: any*/),
                              (v47/*: any*/),
                              (v48/*: any*/),
                              (v38/*: any*/),
                              (v49/*: any*/)
                            ],
                            "type": "JiraFilter",
                            "abstractKey": "__isJiraFilter"
                          },
                          (v40/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v42/*: any*/)
                ]
              },
              {
                "alias": "recentFilters",
                "args": [
                  (v28/*: any*/),
                  (v43/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "FILTER"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v47/*: any*/),
                              (v24/*: any*/),
                              (v48/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v38/*: any*/),
                                  (v49/*: any*/)
                                ],
                                "type": "JiraFilter",
                                "abstractKey": "__isJiraFilter"
                              }
                            ],
                            "type": "JiraCustomFilter"
                          },
                          (v40/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v42/*: any*/)
                ]
              },
              {
                "args": (v29/*: any*/),
                "concreteType": "JiraSystemFilterConnection",
                "kind": "LinkedField",
                "name": "systemFilters",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSystemFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraSystemFilter",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/),
                          (v47/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v38/*: any*/),
                              (v48/*: any*/),
                              (v31/*: any*/),
                              (v49/*: any*/)
                            ],
                            "type": "JiraFilter",
                            "abstractKey": "__isJiraFilter"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "filtersOrder",
            "args": [
              {
                "kind": "Variable",
                "name": "entityAri",
                "variableName": "entityAriFilters"
              },
              (v20/*: any*/)
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": (v46/*: any*/)
          }
        ]
      },
      {
        "condition": "isOperationsExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "OpsgenieQuery",
            "kind": "LinkedField",
            "name": "opsgenie",
            "plural": false,
            "selections": [
              {
                "args": (v29/*: any*/),
                "concreteType": "OpsgenieSavedSearches",
                "kind": "LinkedField",
                "name": "savedSearches",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "starred",
                    "plural": true,
                    "selections": (v50/*: any*/)
                  },
                  {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "sharedWithMe",
                    "plural": true,
                    "selections": (v50/*: any*/)
                  },
                  {
                    "concreteType": "OpsgenieSavedSearch",
                    "kind": "LinkedField",
                    "name": "createdByMe",
                    "plural": true,
                    "selections": (v50/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isPlansExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "favouritePlans",
                "args": [
                  (v28/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": (v35/*: any*/),
                      "type": "PLAN"
                    }
                  },
                  (v36/*: any*/)
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v52/*: any*/)
                  },
                  (v42/*: any*/)
                ]
              },
              {
                "alias": "recentPlans",
                "args": [
                  (v28/*: any*/),
                  (v43/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "PLAN"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v52/*: any*/)
                  },
                  (v42/*: any*/)
                ]
              }
            ]
          },
          {
            "alias": "plansOrder",
            "args": [
              {
                "kind": "Variable",
                "name": "entityAri",
                "variableName": "entityAriPlans"
              },
              (v20/*: any*/)
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": (v46/*: any*/)
          }
        ]
      },
      {
        "condition": "isProjectsExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "canCreateProject",
                "args": [
                  (v28/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "CREATE_PROJECT"
                  }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
              },
              {
                "args": (v29/*: any*/),
                "concreteType": "JiraWorkManagementLicensing",
                "kind": "LinkedField",
                "name": "jwmLicensing",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "currentUserSeatEdition"
                  }
                ]
              }
            ]
          },
          {
            "args": [
              (v28/*: any*/),
              {
                "kind": "Variable",
                "name": "currentURL",
                "variableName": "currentURL"
              }
            ],
            "concreteType": "JiraProjectsSidebarMenu",
            "kind": "LinkedField",
            "name": "jira_projectsSidebarMenu",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "mostRecent",
                "plural": false,
                "selections": (v64/*: any*/)
              },
              {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "mostRecentFromHistory",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  (v53/*: any*/),
                  (v38/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v48/*: any*/),
                  (v57/*: any*/),
                  (v58/*: any*/),
                  (v59/*: any*/),
                  (v60/*: any*/),
                  (v61/*: any*/),
                  (v62/*: any*/),
                  (v63/*: any*/)
                ]
              },
              {
                "args": [
                  (v36/*: any*/)
                ],
                "concreteType": "JiraProjectConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v65/*: any*/),
                  (v42/*: any*/)
                ],
                "storageKey": "favourites(first:15)"
              },
              {
                "args": [
                  (v43/*: any*/)
                ],
                "concreteType": "JiraProjectConnection",
                "kind": "LinkedField",
                "name": "recents",
                "plural": false,
                "selections": [
                  (v65/*: any*/),
                  (v42/*: any*/)
                ],
                "storageKey": "recents(first:20)"
              },
              {
                "kind": "ScalarField",
                "name": "favouriteLimit"
              },
              {
                "kind": "ScalarField",
                "name": "recentLimit"
              },
              {
                "kind": "ScalarField",
                "name": "displayMode"
              },
              (v24/*: any*/),
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNav4SidebarEmptyOnDbErrorRelayProvidertsx",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "QueryError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v45/*: any*/),
                      (v66/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "roadmapsOrder",
            "args": [
              {
                "kind": "Variable",
                "name": "entityAri",
                "variableName": "entityAriRoadmaps"
              },
              (v20/*: any*/)
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": (v46/*: any*/)
          }
        ]
      },
      {
        "condition": "isItamEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v29/*: any*/),
            "kind": "LinkedField",
            "name": "assetsVertical_tenantContext",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "AssetsVerticalTenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContext",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "assetsVerticalWorkspaceAri"
                      },
                      {
                        "concreteType": "AssetsVerticalCompliance",
                        "kind": "LinkedField",
                        "name": "compliance",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isHipaaEnabled"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "AssetsVerticalTenantContextSuccess"
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "checks",
                "variableName": "itamStaticChecks"
              },
              (v28/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "assetsVertical_checkPermissions",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "AssetsVerticalPermissionCheckResult",
                    "kind": "LinkedField",
                    "name": "results",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "resourceId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "permissionId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "permitted"
                      }
                    ]
                  }
                ],
                "type": "AssetsVerticalCheckPermissionsSuccess"
              }
            ]
          },
          {
            "args": [
              (v28/*: any*/),
              (v25/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "HAM"
              }
            ],
            "concreteType": "AssetsVerticalVerticalInstantiationConnection",
            "kind": "LinkedField",
            "name": "assetsVertical_verticalInstantiations",
            "plural": false,
            "selections": [
              {
                "concreteType": "AssetsVerticalVerticalInstantiationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AssetsVerticalVerticalInstantiation",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      (v54/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldFetchInvitedAppShortcuts",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GrowthRecQuery",
            "kind": "LinkedField",
            "name": "growthRecommendations",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "product",
                        "variableName": "invitedAppShortcutsProduct"
                      },
                      {
                        "kind": "Variable",
                        "name": "tenantId",
                        "variableName": "cloudId"
                      },
                      {
                        "kind": "Literal",
                        "name": "useCase",
                        "value": "invitedAppShortcuts"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "context"
                  }
                ],
                "kind": "LinkedField",
                "name": "recommendations",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": true,
                        "selections": [
                          (v31/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "entityId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "reasons"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "score"
                          }
                        ]
                      },
                      {
                        "concreteType": "GrowthRecContextResult",
                        "kind": "LinkedField",
                        "name": "context",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "tenantId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "product"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "useCase"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "sessionId"
                          }
                        ]
                      }
                    ],
                    "type": "GrowthRecRecommendations"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "identifier"
                      },
                      (v45/*: any*/),
                      (v66/*: any*/)
                    ],
                    "type": "QueryError"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "03170320137388b58c5cf52c75a231a74439ce2b30fd9a6321346f09e4fca5d0",
    "metadata": {},
    "name": "GSNQueryPreloaderQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNav4SidebarEmptyOnDbErrorRelayProvidertsx": isNav4SidebarEmptyOnDbErrorEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": isActionMenuWithAddPeopleSpotlightIdEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx": isJpdRoadmapsRecentsEnabled_provider
    }
  }
};
})();

(node as any).hash = "3344bddc3de7ce7d13ea7ca5beb78137";

export default node;
